import React, { useEffect } from "react";
import { FaGithub } from "react-icons/fa";
import AOS from "aos";
import { profile } from "../data/profile";
import "../App.css";

function Projects() {
  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: "ease-out-cubic",
      once: true,
    });
  }, []);

  return (
    <section id="projects" className="site-section site-section--alt">
      <div className="container site-section-inner">
        <header className="section-head">
          {/* <p className="section-eyebrow">Selected work</p> */}
          <h2 className="section-title">Projects</h2>
          <p className="section-lead">
            Product-minded builds across AI, full-stack systems, and developer tools.
          </p>
        </header>

        <div className="projects-grid">
          {profile.projects.map((project, index) => (
            <article
              className="project-item"
              key={project.id}
              data-aos="fade-up"
              data-aos-delay={(index % 3) * 60}
            >
              <div className="project-item-body">
                <h3>{project.title}</h3>
                <div className="project-tech">
                  {project.techStack.map((tech) => (
                    <span key={tech}>{tech}</span>
                  ))}
                </div>
                <p>{project.description}</p>
                {(project.github) && (
                  <div className="project-links">
                    {project.github ? (
                      <a href={project.github} target="_blank" rel="noreferrer">
                        <FaGithub aria-hidden /> Code
                      </a>
                    ) : null}
                  </div>
                )}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Projects;
